<fui-dialog [title]="data.created_at" [translations]="{ close: dictionary.system_close }" (closed)="onClose()">
    <ng-container dialogContent>
        <div class="p-2 whitespace-pre-line font-mono text-xs">
            {{ data.sql }}
        </div>
    </ng-container>

    <ng-container dialogActions>
        <fui-button icon="content-copy" [label]="dictionary.copy" height="mini" (clickEvent)="onCopy()"> </fui-button>
        <fui-button icon="close" [label]="dictionary.system_close" color="light" height="mini" (clickEvent)="onClose()">
        </fui-button>
    </ng-container>
</fui-dialog>
